module.exports = new __parcel__URL__("issue-view-statistics-onboarding.3f045443.gif").toString();